import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'check',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-check wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path d="m8.657 15.85 10.26-10.26a.49.49 0 0 1 .703.01l.7.7a.495.495 0 0 1 .01.704L9.005 18.33a.49.49 0 0 1-.692.002L8.3 18.32l-4.946-4.946a.495.495 0 0 1 .003-.711l.7-.7a.507.507 0 0 1 .711-.004z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-check.svg',
    category: 'Core',
    tags: ['success', 'complete', 'check mark'],
};
export default icon;
